import { render, staticRenderFns } from "./LinkTree.vue?vue&type=template&id=10cd42d6&scoped=true"
import script from "./LinkTree.vue?vue&type=script&lang=js"
export * from "./LinkTree.vue?vue&type=script&lang=js"
import style0 from "./LinkTree.vue?vue&type=style&index=0&id=10cd42d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cd42d6",
  null
  
)

export default component.exports